import { useEffect, useState } from "react";
import { RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { getMyTpl, saveMyTpl } from "./clubApi";
import { Btn, Card, inputCls } from "./ui";

const TAGS = "{nome} cliente · {io} il tuo nome · {link} sua pagina · {giorni} durata percorso · {prodotto} e {data} prodotto in esaurimento";

export default function MyTemplates() {
  const [d, setD] = useState(null);
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    getMyTpl().then((r) => { setD(r); setF(Object.fromEntries(Object.keys(r.titoli).map((k) => [k, r.miei[k] || r.standard[k]]))); }).catch(() => {});
  }, []);
  if (!d) return null;
  const save = async () => {
    setBusy(true);
    try { await saveMyTpl(f); toast.success("Messaggi salvati: li trovi già pronti in ogni cliente"); } catch { toast.error("Errore nel salvataggio"); }
    setBusy(false);
  };
  return (
    <Card className="mt-6 space-y-5" data-testid="my-templates">
      <div>
        <p className="font-semibold">I miei messaggi</p>
        <p className="mt-1 text-xs text-[#9A948A] leading-relaxed">Scrivili come parli tu: valgono per tutti i tuoi clienti. Le parole tra graffe si riempiono da sole: {TAGS}.</p>
      </div>
      {Object.entries(d.titoli).map(([k, t]) => (
        <div key={k}>
          <div className="flex items-center justify-between mb-2">
            <p className="text-xs uppercase tracking-[0.15em] text-[#9A948A]">{t}</p>
            {f[k] !== d.standard[k] && <button onClick={() => setF({ ...f, [k]: d.standard[k] })} className="flex items-center gap-1 text-xs text-[#9A948A] hover:text-white" data-testid={`tpl-${k}-reset`}><RotateCcw size={12} /> Testo standard</button>}
          </div>
          <textarea className={`${inputCls} min-h-[110px] text-sm leading-relaxed`} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`tpl-${k}`} />
        </div>
      ))}
      <Btn onClick={save} disabled={busy} data-testid="tpl-save">{busy ? "Salvo…" : "Salva i miei messaggi"}</Btn>
    </Card>
  );
}
